'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _View2 = require('../../layout/View');

var _View3 = _interopRequireDefault(_View2);

var _Account = require('./Account');

var _Account2 = _interopRequireDefault(_Account);

var _materialUi = require('material-ui');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var AccountsView = (_temp = _class = function (_View) {
  _inherits(AccountsView, _View);

  function AccountsView() {
    _classCallCheck(this, AccountsView);

    return _possibleConstructorReturn(this, _View.apply(this, arguments));
  }

  AccountsView.prototype.render = function render() {
    var _context = this.context,
        Grid = _context.Grid,
        AccountLink = _context.AccountLink;
    var _props = this.props,
        _props$data = _props.data,
        objectsConnection = _props$data.objectsConnection,
        loading = _props$data.loading,
        updateEthAccountProcessor = _props.updateEthAccountProcessor;

    if (!objectsConnection) {
      // if(loading){
      //   return null;
      // }
      return null;
    }

    var items = objectsConnection.edges.map(function (_ref) {
      var node = _ref.node;
      return node;
    });
    return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(Grid, {
      container: true,
      spacing: 16
    }, items.map(function (n) {
      var id = n.id,
          name = n.name;
      return _react2.default.createElement(Grid, {
        key: id,
        item: true,
        xs: 12
      }, _react2.default.createElement(_materialUi.Paper, {
        style: {
          padding: 15
        }
      }, _react2.default.createElement(_Account2.default, {
        data: {
          object: n
        },
        mutate: updateEthAccountProcessor
      }), _react2.default.createElement('p', null, _react2.default.createElement(AccountLink, {
        object: n
      }, 'View account'))));
    })), this.renderPagination());
  };

  return AccountsView;
}(_View3.default), _class.propTypes = _extends({}, _View3.default.propTypes, {
  updateEthAccountProcessor: _propTypes2.default.func.isRequired
}), _temp);
exports.default = AccountsView;
module.exports = exports['default'];